"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexOptionType = exports.convertToProgramComboOptionParams = exports.toLocalSettlementType = exports.toProgramSettlementType = exports.SettlementType = exports.toLocalUnderlyingType = exports.toProgramUnderlyingType = exports.UnderlyingType = exports.toLocalOracleMethod = exports.toProgramOracleMethod = exports.OracleMethod = exports.Version = exports.toLocalKind = exports.toProgramKind = exports.Kind = void 0;
const anchor_1 = require("@project-serum/anchor");
var Kind;
(function (Kind) {
    Kind["UNDEFINED"] = "undefined";
    Kind["CALL"] = "call";
    Kind["PUT"] = "put";
    Kind["CTOKENPUT"] = "cTokenPut";
})(Kind = exports.Kind || (exports.Kind = {}));
function toProgramKind(kind) {
    if (kind == Kind.UNDEFINED) {
        return { undefined: {} };
    }
    if (kind == Kind.CALL) {
        return { call: {} };
    }
    if (kind == Kind.PUT) {
        return { put: {} };
    }
    if (kind == Kind.CTOKENPUT) {
        return { cTokenPut: {} };
    }
    throw Error("Invalid kind.");
}
exports.toProgramKind = toProgramKind;
function toLocalKind(kind) {
    if (Kind.UNDEFINED in kind) {
        return Kind.UNDEFINED;
    }
    if (Kind.CALL in kind) {
        return Kind.CALL;
    }
    if (Kind.PUT in kind) {
        return Kind.PUT;
    }
    if (Kind.CTOKENPUT in kind) {
        return Kind.CTOKENPUT;
    }
    throw Error("Invalid kind.");
}
exports.toLocalKind = toLocalKind;
var Version;
(function (Version) {
    Version[Version["V0"] = 0] = "V0";
})(Version = exports.Version || (exports.Version = {}));
var OracleMethod;
(function (OracleMethod) {
    OracleMethod["SPOT_PRINT"] = "spotPrint";
    OracleMethod["MANUAL_PRINT"] = "manualPrint";
})(OracleMethod = exports.OracleMethod || (exports.OracleMethod = {}));
function toProgramOracleMethod(oracleMethod) {
    if (oracleMethod == OracleMethod.SPOT_PRINT) {
        return { spotPrint: {} };
    }
    if (oracleMethod == OracleMethod.MANUAL_PRINT) {
        return { manualPrint: {} };
    }
    throw Error("Invalid oracle method.");
}
exports.toProgramOracleMethod = toProgramOracleMethod;
function toLocalOracleMethod(oracleMethod) {
    if (OracleMethod.SPOT_PRINT in oracleMethod) {
        return OracleMethod.SPOT_PRINT;
    }
    if (OracleMethod.MANUAL_PRINT in oracleMethod) {
        return OracleMethod.MANUAL_PRINT;
    }
    throw Error("Invalid oracle method.");
}
exports.toLocalOracleMethod = toLocalOracleMethod;
var UnderlyingType;
(function (UnderlyingType) {
    UnderlyingType["NORMAL"] = "normal";
    UnderlyingType["SOLEND_C_TOKEN"] = "solendCToken";
})(UnderlyingType = exports.UnderlyingType || (exports.UnderlyingType = {}));
function toProgramUnderlyingType(underlyingType) {
    if (underlyingType == UnderlyingType.NORMAL) {
        return { normal: {} };
    }
    if (underlyingType == UnderlyingType.SOLEND_C_TOKEN) {
        return { solendCToken: {} };
    }
    throw Error("Invalid underlying type");
}
exports.toProgramUnderlyingType = toProgramUnderlyingType;
function toLocalUnderlyingType(underlyingType) {
    if (UnderlyingType.NORMAL in underlyingType) {
        return UnderlyingType.NORMAL;
    }
    if (UnderlyingType.SOLEND_C_TOKEN in underlyingType) {
        return UnderlyingType.SOLEND_C_TOKEN;
    }
    throw Error("invalid underlying type");
}
exports.toLocalUnderlyingType = toLocalUnderlyingType;
var SettlementType;
(function (SettlementType) {
    SettlementType["UNDEFINED"] = "undefined";
    SettlementType["CASH"] = "cash";
    SettlementType["PHYSICAL"] = "physical";
})(SettlementType = exports.SettlementType || (exports.SettlementType = {}));
function toProgramSettlementType(settlementType) {
    if (settlementType == SettlementType.UNDEFINED) {
        return { undefined: {} };
    }
    if (settlementType == SettlementType.CASH) {
        return { cash: {} };
    }
    if (settlementType == SettlementType.PHYSICAL) {
        return { physical: {} };
    }
    throw Error("Invalid settlement type.");
}
exports.toProgramSettlementType = toProgramSettlementType;
function toLocalSettlementType(settlementType) {
    if (SettlementType.CASH in settlementType) {
        return SettlementType.CASH;
    }
    if (SettlementType.PHYSICAL in settlementType) {
        return SettlementType.PHYSICAL;
    }
    if (SettlementType.UNDEFINED in settlementType) {
        return SettlementType.UNDEFINED;
    }
    throw Error("Invalid settlement type.");
}
exports.toLocalSettlementType = toLocalSettlementType;
function convertToProgramComboOptionParams(paramsArr) {
    return paramsArr.map((params) => {
        return {
            strike: new anchor_1.BN(params.strike),
            kind: toProgramKind(params.kind),
            size: new anchor_1.BN(params.size),
        };
    });
}
exports.convertToProgramComboOptionParams = convertToProgramComboOptionParams;
var FlexOptionType;
(function (FlexOptionType) {
    FlexOptionType[FlexOptionType["Normal"] = 0] = "Normal";
    FlexOptionType[FlexOptionType["Combo"] = 1] = "Combo";
})(FlexOptionType = exports.FlexOptionType || (exports.FlexOptionType = {}));
